import React from 'react';

const FacebookIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
        <defs>
            <style>
                {`.iconface-1{fill:none;}`}
            </style>
        </defs>
        <g id="Capa_2" data-name="Capa 2">
            <g id="Capa_1-2" data-name="Capa 1">
                {/* Cambia 'class' a 'className' */}
                <rect className="iconface-1" width="50" height="50"></rect>
                <path d="M7.32,50H23.63V32.23H17.77V26.37h5.86V19A7.33,7.33,0,0,1,31,11.72h7.32v5.86H32.42a2.93,2.93,0,0,0-2.93,2.93v5.86H38l-1,5.86H29.49V50H42.68A7.34,7.34,0,0,0,50,42.68V7.32A7.34,7.34,0,0,0,42.68,0H7.32A7.34,7.34,0,0,0,0,7.32V42.68A7.34,7.34,0,0,0,7.32,50ZM2.93,7.32A4.4,4.4,0,0,1,7.32,2.93H42.68a4.4,4.4,0,0,1,4.39,4.39V42.68a4.4,4.4,0,0,1-4.39,4.39H32.42V35.16h7.1l2-11.72H32.42V20.51h8.79V8.79H31A10.27,10.27,0,0,0,20.7,19v4.4H14.84V35.16H20.7V47.07H7.32a4.4,4.4,0,0,1-4.39-4.39Z"></path>
            </g>
        </g>
    </svg>
);

export default FacebookIcon;